import Compressor from 'compressorjs';

/**
 * Gets a normalized (compressed) version of a file
 * @param file The file to normalize
 * @returns A promise resolving to the normalized file
 */
export const getNormalizedFile = (file: File): Promise<File> => {
  return new Promise((resolve, reject) => {
    new Compressor(file, {
      quality: 0.6,
      maxWidth: 4096,
      maxHeight: 4096,
      success(normalizedFile) {
        resolve(normalizedFile as File);
      },
      error(error) {
        reject(error);
      },
    });
  });
};

/**
 * Gets the dimensions of an image from a base64 string
 * @param base64 The base64 string of the image
 * @returns A promise resolving to the width and height of the image
 */
export function getImageDimensions(base64: string): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
    };
    img.onerror = reject;
    img.src = base64;
  });
}
